<template>
    <div>
        <div>
            <vue-headful :title="$t('title_dashboard')" description="title" />
            <OnBoardingContent />
        </div>
        <v-container fluid>
            <v-row class="mx-2">
                <TopBar />
                <!-- <AssignedBook /> -->
                <v-row>
                    <v-col cols="12" md="6" class="pa-0 pa-md-3">
                        <v-col cols="12" class="w-100 mt-2 home-carousel">
                            <CarouselBooks />
                        </v-col>
                    </v-col>
                    <v-col cols="12" md="6" class="pa-0 pa-sm-3">
                        <v-col cols="12" class="w-100 mt-2 fill-height custom-card"> 
                            <EventsSection />
                        </v-col>
                    </v-col>
                </v-row>
            </v-row>                
            <v-row class="ma-2 d-none d-sm-flex">
                <v-col cols="12" md="6" class="pa-0 pa-md-3 pl-md-0">
                    <v-col cols="12" class="pa-0 h-100 mt-0">
                        <CarouselMostPopular />
                    </v-col>
                </v-col>
                <v-col cols="12" md="6" class="pa-0 pa-md-3 pr-md-0 mt-3 mt-md-0">
                    <v-col cols="12" class="w-100 fill-height custom-card">
                        <HeadChallengeCard
                            @openDialog="openDialog"
                        />
                    </v-col>
                </v-col>
            </v-row>
            <PrizeChallenge
                :dialogVisible="dialogVisible"
                @closeDialog="closeDialog"
                @updateDialog="updateDialog"
            />
        </v-container>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import AssignedBook from '@/components/home/AssignedBook.vue'
import CentralSection from '@/components/home/CentralSection.vue'
import Ranking from '@/components/home/Ranking.vue'
import SuperRecommended from '@/components/home/SuperRecommended.vue'
import TopBar from '@/components/home/TopBar.vue'
import OnBoardingContent from '@/components/onBoarding/OnBoardingContent.vue'
import CarouselBooks from '@/components/home/CarouselBooks.vue'
import EventsSection from '@/components/home/EventsSection.vue'
import HeadChallengeCard from '@/components/challenge/HeadChallengeCard.vue'
import PrizeChallenge from '@/components/challenge/PrizeChallenge.vue'
import CarouselMostPopular from '@/components/home/CarouselMostPopular.vue'

export default {
    data() {
        return {
            dialogVisible: false,
        }
    },
    computed: {
        ...mapState({
            user_loaded: (state) => state.userData.user_loaded,
        }),
    },
    components: {
        AssignedBook,
        CentralSection,
        Ranking,
        SuperRecommended,
        TopBar,
        OnBoardingContent,
        CarouselBooks,
        EventsSection,
        HeadChallengeCard,
        PrizeChallenge,
        CarouselMostPopular,
    },
    methods: {
        openDialog() {
            this.dialogVisible = true
        },
        closeDialog() {
            this.dialogVisible = false
        },
        updateDialog(value) {
            this.dialogVisible = value
        },
    },
}
</script>

<style lang="scss">
.home-carousel{
    border-radius: 1rem;
    height: 100%;
    @media screen and (min-width: 960px) {
        .header-section * {
            color: white;
        }
        background: linear-gradient(310.15deg, #A295DA -3.77%, #7764CA 29.51%, #6857B2 65.63%, #514585 93.49%);
    }
    @media screen and (max-width: 960px) {
        margin-bottom: 15px;
    }
    @media screen and (max-width: 600px) {
        margin-bottom: 5px;
    }
}
</style>
